import moment from 'moment-timezone';

/***
 * formats date as per the hours passed in the formart for ex: 8:AM
 * adjusts the date as per this hour
 */
export const getHourUtility = (dateString, timeString) => {
  let [Hours, Period] = timeString.split(':');
  Hours = parseInt(Hours);
  if (Period === 'PM') {
    Hours += 12;
  }
  if (Hours === 12) {
    Hours = 0;
  }
  if (Hours === 24) {
    Hours -= 12;
  }

  const scheduleDateStartOfDay = moment(dateString).startOf('day');
  let scheduleDateAfterAddingHours = moment(dateString).startOf('day').add({
    h: Hours
  });
  let scheduleDate = undefined;
  if (!scheduleDateStartOfDay.isDST() && scheduleDateAfterAddingHours.isDST()) {
    // if after adding hours, cst changes to cdt. we subtract 1 hour from the hours to get the correct schedule date in terms on cdt
    scheduleDate = scheduleDateStartOfDay
      .add({
        h: Hours
      })
      .subtract(1, 'hour');
  } else if (scheduleDateStartOfDay.isDST() && !scheduleDateAfterAddingHours.isDST()) {
    // there could be a possibility a we are changing the  schedule date of a job from 4th of Feb 2020,3:00AM to 1st of Nov,3:00 AM even though both are in cst time zone,
    // but the problem comes when we do start of day on the new scheduleDate then it will become 1st of Nov,12:00AM which is cdt and when we add hours to that it becomes cst so we need to add an extra hour to get the correct time
    scheduleDate = scheduleDateStartOfDay.add({
      h: Hours + 1
    });
  } else {
    scheduleDate = scheduleDateStartOfDay.add({
      h: Hours
    });
  }
  return scheduleDate;
};

export const getReverseHourUtility = dateString => {
  const scheduleDate = moment.utc(dateString);
  const hour = scheduleDate.hours();
  let period = 'AM';
  let adjustedHour = hour;

  // Convert to 12-hour format
  if (adjustedHour >= 12) {
    period = 'PM';
    if (adjustedHour > 12) {
      adjustedHour -= 12;
    }
  }

  if (adjustedHour === 0) {
    adjustedHour = 12;
  }

  return {
    date: scheduleDate.toDate(),
    hour: adjustedHour,
    period: period
  };
};
